var _style, _circle, _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoftwareDevLeadsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000147912300933546468860000003529756180121890176_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 183.2 183.2",
    style: {
      enableBackground: "new 0 0 183.2 183.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.4768,
    y1: 94.3738,
    x2: 181.7639,
    y2: 94.3738,
    gradientTransform: "matrix(1 0 0 -1 -3.046392e-03 185.9994)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#386AFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B86F6"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 91.6,
    cy: 91.6,
    r: 90.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.6,3c48.9,0,88.6,39.8,88.6,88.6s-39.8,88.6-88.6,88.6S3,140.5,3,91.6S42.8,3,91.6,3 M91.6,0 C41,0,0,41,0,91.6s41,91.6,91.6,91.6s91.6-41,91.6-91.6S142.2,0,91.6,0L91.6,0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.6,65.2c-4.4-7.6-10.5-13.5-18.5-17.8c-7.9-4.2-17.4-6.4-28.2-6.4H79.8v21.1h14.6 c9.1,0,16.3,2.6,21.5,7.9c5.2,5.2,7.8,12.4,7.8,21.6s-2.6,16.2-7.8,21.5c-5.2,5.3-12.4,7.9-21.5,7.9H79.8v21.1h16.2 c10.9,0,20.3-2.1,28.2-6.4c7.9-4.3,14.1-10.2,18.5-17.8c4.4-7.6,6.6-16.4,6.6-26.3S147,72.8,142.6,65.2L142.6,65.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.6,
    y: 121.1,
    className: "st3",
    width: 25.1,
    height: 21.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.6,
    y: 41.1,
    className: "st3",
    width: 25.1,
    height: 21.1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.6,75.8L86.6,75.8 M86.6,75.8c0,0.9-0.3,1.7-1,2.4l-16,16v7.8l-4.9,5.5V94.2l-16-16c-0.7-0.7-1-1.5-1-2.4 L86.6,75.8 M86.6,73.8H47.8c-1.1,0-2,0.9-2,2c0,1.4,0.5,2.8,1.6,3.8L62.7,95v12.4c0,0.8,0.5,1.6,1.3,1.9c0.2,0.1,0.5,0.1,0.7,0.1 c0.6,0,1.1-0.2,1.5-0.7l4.9-5.5c0.3-0.4,0.5-0.8,0.5-1.3V95l15.4-15.4c1-1,1.5-2.3,1.6-3.7c0,0,0-0.1,0-0.1 C88.6,74.7,87.8,73.8,86.6,73.8L86.6,73.8L86.6,73.8z M86.6,77.8L86.6,77.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDevLeadsLogo);
export default __webpack_public_path__ + "static/media/softwareDevLeadsLogo.60e60dcc49f4ed9e98c160e9df1547a2.svg";
export { ForwardRef as ReactComponent };